/**
 * Accessibility helpers active on every page.
 *
 * Currently: ensure the skip link moves focus to <main> reliably across
 * browsers (some don't focus the target of an in-page link without tabindex).
 */
export function initA11y() {
  const skip = document.querySelector('.emc-skip-link');
  const main = document.getElementById('main');
  if (!skip || !main) return;

  skip.addEventListener('click', () => {
    main.setAttribute('tabindex', '-1');
    main.focus({ preventScroll: false });
    main.addEventListener(
      'blur',
      () => main.removeAttribute('tabindex'),
      { once: true }
    );
  });
}
